import { Box, Typography } from "@mui/material"

const Prediction = ({ prediction }) => {
    return (
        <Box>
            <Typography
                variant="body1"
                sx={{
                    lineHeight: 1.6,
                    mb: 1.5,
                    fontSize: "1rem",
                }}
            >
                {prediction.prediction}
                {prediction.commandNo && (
                    <Typography
                        component="span"
                        variant="caption"
                        color="text.secondary"
                        sx={{
                            ml: 1,
                            fontSize: "0.875rem",
                        }}
                    >
                        ({prediction.commandNo})
                    </Typography>
                )}
                {prediction.tag &&
                    prediction.tag.length > 0 && (
                        <Typography
                            component="span"
                            variant="caption"
                            color="text.secondary"
                            sx={{
                                ml: 1,
                                fontSize: "0.875rem",
                            }}
                        >
                            (
                            {Array.isArray(prediction.tag)
                                ? prediction.tag.join(", ")
                                : prediction.tag}
                            )
                        </Typography>
                    )}
            </Typography>

            {/* translation */}
            {prediction.translatedPrediction && (
                <Typography
                    variant="body1"
                    sx={{
                        lineHeight: 1.6,
                        mb: 1.5,
                        fontSize: "1rem",
                        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                        fontWeight: 700,
                        color: "text.secondary",
                    }}
                >
                    {prediction.translatedPrediction}
                </Typography>
            )}
        </Box>
    )
}

export default Prediction
